// Conteúdo institucional das seguradoras parceiras.
// Usado pelas páginas /seguradoras/:slug e pela página de Dúvidas.

import AssistCardLogo from '../assets/logos/partners/assist-card.svg';
import UniversalLogo from '../assets/logos/partners/universal-assistance.svg';
import AffinityLogo from '../assets/logos/partners/affinity.svg';

// Coberturas comuns do seguro viagem. As coberturas exatas variam conforme
// o plano escolhido dentro de cada seguradora.
const COMMON_COVERAGES = [
  'Assistência Médica e Hospitalar',
  'Cobertura para COVID-19',
  'Assistência Odontológica',
  'Assistência Farmacêutica',
  'Regresso Sanitário',
  'Traslado Médico',
  'Traslado de Corpo',
  'Seguro Bagagem',
  'Despesas Jurídicas',
];

export const INSURERS = [
  {
    slug: 'assist-card',
    name: 'Assist Card',
    logo: AssistCardLogo,
    tagline: 'Assistência integral em viagens desde 1972',
    description:
      'A Assist Card é uma empresa fundada na Suíça em 1972 e, desde 2011, ' +
      'integrante do grupo STARR COMPANIES. Pioneira no conceito de assistência ' +
      'ao viajante, oferece atendimento 24 horas por dia, 7 dias por semana, em ' +
      'qualquer lugar do mundo, sem exigir desembolso do cliente. Administra a ' +
      'maior rede global de provedores, com alto padrão de qualidade.',
    stats: [
      { value: '10 milhões', label: 'de viajantes assegurados' },
      { value: '190 países', label: 'com atendimento direto' },
      { value: '74 escritórios', label: 'ao redor do mundo' },
      { value: '50 anos', label: 'de experiência no mercado' },
    ],
    coverages: COMMON_COVERAGES,
    emergency: [
      { label: 'Do exterior (a cobrar)', value: '+55 11 3191-8700', href: 'tel:+551131918700' },
      { label: 'No Brasil', value: '0800 170 6133', href: 'tel:08001706133' },
      { label: 'WhatsApp', value: '+54 9 11 2703-9665', href: 'https://wa.me/5491127039665', whatsapp: true },
    ],
    institutional: {
      'Razão Social': 'Assist Card do Brasil LTDA',
      CNPJ: '00.027.571/0001-10',
      Endereço: 'Avenida Paulista, 1079 – Conj. 161 – São Paulo/SP',
      Seguradora: 'Starr International Brasil Seguradora S.A.',
      // Condições gerais "Bilhete de Seguro Viagem Starr", versão dez/2025
      // (assistcard.com/document/603). Conferido em 06/10/2026.
      'Processo SUSEP': '15414.629785/2022-26',
    },
  },
  {
    slug: 'universal',
    name: 'Universal Assistance',
    logo: UniversalLogo,
    tagline: 'Assistência integral aos viajantes há mais de 40 anos',
    description:
      'A Universal Assistance oferece serviços de assistência integral aos ' +
      'viajantes há mais de 40 anos, com atendimento global 24 horas por dia, ' +
      'todos os dias do ano. Faz parte do Cover More Group, a divisão de seguros ' +
      'de viagem do Zurich Insurance Group, um dos maiores grupos seguradores do mundo.',
    stats: [
      { value: '20 milhões', label: 'de viajantes assegurados por ano' },
      { value: '500 mil', label: 'casos atendidos por ano' },
      { value: '3.000', label: 'colaboradores em 21 países' },
      { value: '40 anos', label: 'de atuação no mercado' },
    ],
    coverages: COMMON_COVERAGES,
    emergency: [
      { label: 'Do exterior (a cobrar)', value: '+55 11 4323-7770', href: 'tel:+551143237770' },
      { label: 'No Brasil', value: '0800 761-9254', href: 'tel:08007619254' },
      {
        label: 'E-mail',
        value: 'assistenciabrasil@universal-assistance.com',
        href: 'mailto:assistenciabrasil@universal-assistance.com',
      },
    ],
    institutional: {
      'Razão Social': 'ASSISTBRAS S/A – Serviço de Assistência ao Viajante Ltda',
      CNPJ: '07.139.957/0001-62',
      Endereço: 'Avenida Ipiranga, 353 – Centro – CEP 01046-010 – São Paulo/SP',
      Seguradora: 'Zurich Minas Brasil Seguros S.A. (CNPJ 17.197.385/0001-21)',
      // Condições gerais "Seguro Zurich Viagem - Bilhete"
      // (universal-assistance.com/br/condicoes-gerais). Conferido em 06/10/2026.
      'Processo SUSEP': '15414.644662/2023-04',
    },
  },
  {
    slug: 'affinity',
    name: 'Affinity',
    logo: AffinityLogo,
    tagline: 'Mais de 30 anos de experiência em seguro viagem',
    description:
      'A Affinity possui mais de 30 anos de experiência em seguros viagem. ' +
      'Associada ao World Travel Assist e, desde 2020, à Chubb Seguros S/A — a ' +
      'maior seguradora dos Estados Unidos. Oferece atendimento 24 horas por dia, ' +
      '7 dias por semana, com uma equipe especializada e comprometida com ' +
      'qualidade, dedicação e eficiência.',
    stats: [
      { value: '30+ anos', label: 'de experiência em seguro viagem' },
      { value: 'Grupo Chubb', label: 'maior seguradora dos EUA, desde 2020' },
      { value: '24/7', label: 'atendimento todos os dias do ano' },
      { value: 'World Travel', label: 'Assist — rede internacional de assistência' },
    ],
    coverages: COMMON_COVERAGES,
    emergency: [
      { label: 'Do exterior (a cobrar)', value: '+55 11 3132-9308', href: 'tel:+551131329308' },
      { label: 'No Brasil', value: '0800 038 0621', href: 'tel:08000380621' },
      { label: 'WhatsApp', value: '+1 863 201 4897', href: 'https://wa.me/18632014897', whatsapp: true },
      {
        label: 'E-mail',
        value: 'assistencia@affinityseguro.com.br',
        href: 'mailto:assistencia@affinityseguro.com.br',
      },
    ],
    institutional: {
      'Razão Social': 'ASPAS Turismo, Viagens e Assistência Internacional S/A',
      CNPJ: '17.846.647/0001-31',
      Endereço: 'Avenida São Luís, 192 – Sobreloja – CEP 01046-000 – Centro – São Paulo/SP',
      // A Affinity publica condições gerais de duas seguradoras (Chubb, versão
      // 2019, e Kovr, versão 2024); a seguradora de cada compra aparece no bilhete.
      // Fonte: affinityseguro.com.br/img/PDF/General_conditions/. Conferido em 06/10/2026.
      Seguradora: 'Chubb Seguros Brasil S.A. (CNPJ 03.502.099/0001-18) ou Kovr Seguradora S.A., conforme o plano',
      'Processo SUSEP': '15414.900439/2015-34 (Chubb) · 15414.652264/2024-34 (Kovr)',
    },
  },
];

export const getInsurerBySlug = (slug) =>
  INSURERS.find((insurer) => insurer.slug === slug);
